<template>
  <div class="container db-adapter-builder">
    <v-row class="page-header">
      <v-col class="page-title" cols="12">
        <v-toolbar-title class="font-bold"
          >DB Adapter Builder<span style="font-size: 14px; font-weight: 400" v-if="fullName">
            - {{ fullName }}</span
          ></v-toolbar-title
        >
      </v-col>
    </v-row>

    <v-row class="custom-form-control custom-form-control-type-2 custom-figma-1">
      <v-col cols="12" class="pt-0 pb-0">
        <system-progress
          :sysloading="isLoading"
          :sysloadingTitle="sysloadingTitle"
        ></system-progress>
        <v-row>
          <v-col
            class="comm-header-col data-query-section pb-0 pt-0 mt-0 custom-field-combo custom-figma-1"
            cols="12"
            lg="3"
            md="3"
          >
            <v-row>
              <v-col cols="12" lg="12" md="12" class="pt-0 pb-0">
                <v-select
                  v-model="db_item.dba_type"
                  :items="types"
                  :menu-props="{ offsetY: true }"
                  label="Type"
                  class="custom-selectbox"
                  dense
                  filled
                  hide-details
                  @change="changeTypeDBMapper(db_item.dba_type)"
                  :disabled="this.param.options.isEdit"
                ></v-select>
              </v-col>
            </v-row>
          </v-col>
          <v-col
            class="comm-header-col data-query-section pb-0 pt-0 mt-0 custom-field-combo custom-figma-1"
            cols="12"
            lg="6"
            md="6"
          >
            <v-row>
              <v-col
                v-if="
                  !db_item.dba_type ||
                    db_item.dba_type === 'D2J' ||
                    db_item.dba_type === 'D2D' ||
                    db_item.dba_type === 'D2F'
                "
                cols="12"
                lg="6"
                md="6"
                class="pt-0 pb-0"
              >
                <v-autocomplete
                  v-model="db_item.source_agent_id"
                  :items="agentList"
                  :menu-props="{ offsetY: true }"
                  @change="onChangeAgent()"
                  label="Agent"
                  class="custom-selectbox"
                  hide-details
                  dense
                  filled
                ></v-autocomplete>
              </v-col>
              <v-col
                v-if="db_item.dba_type === 'J2D' || db_item.dba_type === 'D2D'"
                cols="12"
                lg="6"
                md="6"
                class="pt-0 pb-0"
              >
                <v-autocomplete
                  v-model="db_item.target_agent_id"
                  :items="agentList"
                  :menu-props="{ offsetY: true }"
                  @change="onChangeAgent()"
                  label="Agent"
                  class="custom-selectbox"
                  hide-details
                  dense
                  filled
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-row class="page-tab">
      <v-col class="pt-0" cols="12">
        <v-tabs v-model="tab" class="custom-tab-bar" background-color="primary">
          <v-tab
            :class="[$vuetify.theme.dark ? 'mr-1' : '']"
            v-for="item in items"
            :key="item.tab"
            :disabled="item.isDisable"
          >
            {{ item.content }}
          </v-tab>
        </v-tabs>

        <v-tabs-items class="custom-tab-content" style="height: 585px" v-model="tab">
          <v-tab-item no-animation :key="'dbint'">
            <DBInterfaceConfig
              ref="DBInterfaceConfig"
              :type.sync="db_item.dba_type"
              :comId.sync="db_item.comp_id"
              :agentId.sync="db_item.agent_id"
              :dbaId="$route.params.id"
              :targetAgentId.sync="db_item.target_agent_id"
              :dbConfigList.sync="dbConfigList"
              :dbInstnList.sync="dbInstnList"
              :controlTableList.sync="controlTableList"
              @isLoad="isLoad"
              @save-db-config="saveDBConfig"
              @reset-data="resetData"
              @change-disabled-tab="changeDisabledTab"
              @change-name="changeName"
              @delete-db-config="deleteDBConfig"
            ></DBInterfaceConfig>
          </v-tab-item>
          <v-tab-item no-animation :key="'dbmap'">
            <DBMapping
              :type.sync="db_item.dba_type"
              :dbMapperId.sync="db_item.dba_mapper_id"
              :resultTestField="resultTestField"
              :outputFileContent="outputFileContent"
              :checkIn.sync="checkIn"
              @isCheckIn="isCheckIn"
              @isLoad="isLoad"
              @openLoadFile="openLoadFile($event)"
              @openXmlMapperListDialog="openXmlMapperListDialog($event)"
              @openDBAdapterSQL="openDBAdapterSQL"
              @close-dialog-sql-group="closeSQLDialog"
              @close-mapper-list-dialog="closeMapperListDialog"
              @change-result-test="changeResultTest"
              @reset-result-test-field="resetResultTestField"
              @change-type-db-mapper="changeTypeDBMapper"
              @saveMapperCheckIn="saveMapperCheckIn"
              ref="mapper"
            >
              ></DBMapping
            >
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>

    <v-row v-if="$auth.manage">
      <v-col class="btn-form-control data-query-section d-flex justify-end pt-0" cols="12" lg="12">
        <div style="width: fit-content; padding-right: 30px" class="text-left">
          <p v-for="(item, index) in messageList" :key="index" class="mb-0 text-validate">
            <icon-svg style="display: inline;" iconName="validate" />{{ item }}
          </p>
        </div>
        <div class="mr-1">
          <v-btn class="btn-active btn-execute" @click="testMapper">Execute for Testing</v-btn>
        </div>
        <div>
          <v-btn class="btn-active btn-search" @click="saveDBAdapter">
            Save DB Adapter
          </v-btn>
        </div>
      </v-col>
    </v-row>

    <dialogWindow
      ref="messageDialog"
      size="max"
      :info="checkDialogTitle"
      :detail="checkDialogInfo"
      :color="checkDialogColor"
    ></dialogWindow>
    <dialogWindow
      ref="validateDate"
      size="max"
      :detail="detailValid"
      color="validation"
    ></dialogWindow>

    <div v-for="dialog in dialogs" :key="dialog.id" class="dialogs">
      <xmlMapperList
        v-if="dialog.type == 'xmlMapperList'"
        :id="dialog.id"
        :closeDialog="removeDialog"
        :dragEnd="dialogDragEnd"
        :dragStart="selectDialog"
        :move="dialogDragEnd"
        :options="dialog.options"
        @openDBMapperVersion="openDBMapperVersion($event)"
        class="maplist-layout-dialog"
        ref="xmlMapperList"
      >
      </xmlMapperList>
      <versionHistory
        v-if="dialog.type == 'versionHistory'"
        class="custom-dialog mapper-version"
        :closeDialog="removeDialog"
        :dragEnd="dialogDragEnd"
        :dragStart="selectDialog"
        :move="dialogDragEnd"
        :options="dialog.options"
        @refreshMapList="refreshMapList()"
        :id="dialog.id"
        ref="versionHistory"
      ></versionHistory>
      <load-file-dialog
        v-if="dialog.type == 'loadFile'"
        :id="dialog.id"
        :ref="'dialog-' + dialog.id"
        :closeDialog="removeDialog"
        :prs="prs"
        :dragEnd="dialogDragEnd"
        :dragStart="selectDialog"
        :move="dialogDragEnd"
        :options="dialog.options"
        class="load-file-dialog"
      >
      </load-file-dialog>
      <DBAdapterSQL
        v-if="dialog.type == 'sqlGroupView'"
        :type="db_item.dba_type"
        :id="dialog.id"
        :closeDialog="removeDialog"
        :dragEnd="dialogDragEnd"
        :dragStart="selectDialog"
        :move="dialogDragEnd"
        :options="dialog.options"
        :typeDBList="typeDBList"
        :searchTypeDBList="searchTypeDBList"
        ref="sqlGroupView"
        style="width: 1425px !important"
      ></DBAdapterSQL>
      <queryPool
        v-if="dialog.type == 'QueryPool'"
        class="maplist-layout-dialog mapbuilder-scanner-list codetable-list"
        :id="dialog.id"
        ref="CodeDataPool"
        :closeDialog="removeDialog"
        :dragEnd="dialogDragEnd"
        :dragStart="selectDialog"
        :move="dialogDragEnd"
        :options="dialog.options"
        :typeDBList="typeDBList"
        :searchTypeDBList="searchTypeDBList"
      ></queryPool>
      <addSqlGroup
        v-if="dialog.type == 'addSqlGroup'"
        class="maplist-layout-dialog add-code-dialog"
        :id="dialog.id"
        :ref="'dialog-' + dialog.id"
        :closeDialog="removeDialog"
        :dragEnd="dialogDragEnd"
        :dragStart="selectDialog"
        :move="dialogDragEnd"
        :options="dialog.options"
        :types="searchTypeDBList"
      ></addSqlGroup>
      <addD2DSqlGroup
        v-if="dialog.type == 'addD2DSqlGroup'"
        class="maplist-layout-dialog add-code-dialog"
        :id="dialog.id"
        :ref="'dialog-' + dialog.id"
        :agentId="db_item.agent_id"
        :targetAgentId="db_item.target_agent_id"
        :closeDialog="removeDialog"
        :dragEnd="dialogDragEnd"
        :dragStart="selectDialog"
        :move="dialogDragEnd"
        :options="dialog.options"
        :types="searchTypeDBList"
        style="width: 1300px !important"
      ></addD2DSqlGroup>
    </div>
  </div>
</template>

<script>
import DBInterfaceConfig from '@/vue-caas/views/dbadapter/DBInterfaceConfig.vue';
import loadFileDialog from '@/vue-caas/views/dbadapter/LoadFile.vue';
import DBMapping from '@/vue-caas/views/dbadapter/DBMapping.vue';
import dialogWindow from '@/vue-dlb/components/NewDialog.vue';
import xmlMapperList from '@/vue-caas/views/dbadapter/DBMapperList.vue';
import versionHistory from '@/vue-caas/views/dbadapter/DBMapperVersionHistory.vue';
import DBAdapterSQL from '@/vue-caas/views/dbadapter/DBAdapterSQL.vue';
import queryPool from '@/vue-caas/views/dbadapter/SqlPool.vue';
import addSqlGroup from '@/vue-caas/views/dbadapter/AddSqlGroup.vue';
import addD2DSqlGroup from '@/vue-caas/views/dbadapter/AddD2DSqlGroup.vue';
import EventBus from '@/vue-caas/views/process/component/event-bus.js';
import { mapActions, mapGetters, mapState } from 'vuex';
import { nullOrEmpty } from '@/vue-dlb/common/common';
import IconSvg from '@/vue-caas/components/IconBase.vue';
import SystemProgress from '@/vue-dlb/components/SystemProgress.vue';

export default {
  components: {
    DBInterfaceConfig,
    DBMapping,
    dialogWindow,
    xmlMapperList,
    versionHistory,
    loadFileDialog,
    DBAdapterSQL,
    queryPool,
    addSqlGroup,
    addD2DSqlGroup,
    IconSvg,
    SystemProgress,
  },
  data() {
    return {
      isLoading: false,
      messageList: [],
      codeCtg: '',
      dialogs: [],
      dialogId: 1,
      arrLayoutDialog: [],
      tab: null,
      items: [
        {
          tab: 'dbint',
          content: 'DB Interface Configuration',
          isDisable: false,
        },
        { tab: 'dbmap', content: 'DB Mapping', isDisable: true },
      ],
      types: [],
      typeDBList: [
        { text: 'select', value: 'select' },
        { text: 'insert', value: 'insert' },
        { text: 'update', value: 'update' },
        { text: 'delete', value: 'delete' },
      ],
      searchTypeDBList: [
        { text: this.$t('lbl.common.conditionSearch.all'), value: '' },
        { text: 'select', value: 'select' },
        { text: 'insert', value: 'insert' },
        { text: 'update', value: 'update' },
        { text: 'delete', value: 'delete' },
      ],
      db_item: {
        dba_type: 'D2J',
      },
      companyList: [],
      agentList: [],
      param: {},
      dbConfigList: [],
      dbInstnList: [],
      controlTableList: [],
      saveData: {},
      saveMapper: {},
      saveAll: {},
      checkDialogTitle: '',
      checkDialogColor: 'warning',
      checkDialogInfo: '',
      flatFileVersionHistoryItem: '',
      xmlMapperType: '',
      sqlList: [],
      mapperFileContent: '',
      mapperFileName: '',
      mapperFileExtension: '',
      mapperFileStatus: '',
      mapperFileID: '',
      outputFileContent: '',
      resultTest: {},
      resultTestField: '',
      isJsonFile: false,
      detailValid: '',
      jsonFileContent: '',
      checkIn: false,
      dba_name: '',
      dba_ins: '',
      allowSave: false,
    };
  },

  computed: {
    ...mapState('common', {
      CommMsgList: 'CommMsgList',
      sysloadingTitle: 'sysloadingTitle',
    }),
    ...mapState('analysis', {
      fileViewWindowParam: 'fileViewWindowParam',
    }),
    ...mapGetters([
      'agentAdapterList',
      'dbAdapterConfigList',
      'dbInstanceList',
      'interfaceControlTableList',
      'dbConfigId',
      'dbMapperId',
    ]),
    fullName: {
      get() {
        let index = this.agentList.findIndex((e) => e.value === this.db_item.agent_id);
        let agentNm = '';
        if (index > -1) agentNm = this.agentList[index].text;
        return this.dba_name && this.db_item.dba_type
          ? `(${agentNm}_${this.dba_ins}) ${this.dba_name}_${this.db_item.dba_type}`
          : '';
      },
    },
  },

  async created() {
    this.isLoading = true;
    this.getMapperTypeList();
    if (this.$route.params.id) {
      this.param = this.fileViewWindowParam[this.$route.params.id];
      this.companyList = this.param.options.company;
      if (this.param.options.isEdit) {
        this.items[1].isDisable = false;
        this.db_item = Object.assign(this.db_item, this.param.editedItem);
        this.dba_name = this.db_item.dba_name;
      } else {
        Store.commit('SET_STORE_DB_MAPPER_ID', '');
        this.db_item.dba_type = 'D2J';
        if (this.companyList.length > 0) {
          this.db_item.comp_id = this.companyList[0].value || '';
        }
      }
      await this.getAgentAdapterList();
      for (let i = 0; i < this.agentAdapterList.length; i += 1) {
        const tmp = this.agentAdapterList[i];
        tmp.text = this.agentAdapterList[i].agentNm + ' - ' + this.agentAdapterList[i].compNm;
        tmp.value = this.agentAdapterList[i].agentId;
        this.agentList.push(tmp);
      }
      if (!this.param.options.isEdit && this.agentList.length > 0) {
        this.db_item.agent_id = this.agentList[0].value;
      }
      if (this.db_item.agent_id) {
        await this.getDbAgentListByAgent({
          agent_id: this.db_item.agent_id,
          target_agent_id: this.db_item.target_agent_id,
        });
        await this.getDBAdapterConfigList({
          agent_id: this.db_item.agent_id,
          target_agent_id: this.db_item.target_agent_id,
        });
        this.dbConfigList = this.dbAdapterConfigList;
        this.dbInstnList = this.dbInstanceList;
        this.controlTableList = this.interfaceControlTableList;
      }
      if (this.db_item.dba_type === 'D2J' || this.db_item.dba_type === 'D2F') {
        this.db_item.source_agent_id = this.db_item.agent_id;
      } else if (this.db_item.dba_type === 'J2D') {
        this.db_item.target_agent_id = this.db_item.agent_id;
      } else if (this.db_item.dba_type === 'D2D') {
        this.db_item.source_agent_id = this.db_item.agent_id;
      }
    }

    window.addEventListener('beforeunload', (e) => {
      if (this.$refs.DBInterfaceConfig.allowSave || !this.$refs.mapper.isValidMapper) {
        e.preventDefault();
        return;
      }
    });
    EventBus.$on('openSqlPool', this.openQueryPoolDialog);
    EventBus.$on('open-dialog-d2d', this.openAddD2DSQLGroup);
    EventBus.$on('open-dialog-add', this.openAddSQLGroup);
    EventBus.$on('remove-dialog-add', this.removeDialog);
    EventBus.$on('refeshListSQLManage', this.refeshListSQLManage);

    this.isLoading = false;
  },
  methods: {
    ...mapActions(['getAgentAdapterList', 'getDBAdapterConfigList', 'getDbAgentListByAgent']),
    refreshMapList() {
      EventBus.$emit('refresh-map-list');
    },
    getMapperTypeList() {
      this.$store.dispatch('caascommon/getComCdList', { grpCd: 'P15' }).then(() => {
        let mapperTypeList = this.$store.getters['caascommon/comCdList'];
        mapperTypeList.map((item) => {
          this.types.push({ text: item.text, value: item.value });
        });
      });
    },
    isCheckIn(checkIn) {
      this.checkIn = checkIn;
    },
    isLoad(load) {
      this.isLoading = load;
    },
    changeTypeDBMapper(type) {
      this.db_item.dba_type = type;
      if (this.db_item.dba_type === 'D2J' || this.db_item.dba_type === 'D2F') {
        this.db_item.source_agent_id = this.db_item.agent_id;
        this.db_item.target_agent_id = null;
      } else if (this.db_item.dba_type === 'J2D') {
        this.db_item.target_agent_id = this.db_item.agent_id;
        this.db_item.source_agent_id = null;
      } else if (this.db_item.dba_type === 'D2D') {
        this.db_item.source_agent_id = this.db_item.agent_id;
        this.db_item.target_agent_id = null;
      }
    },
    closeSQLDialog() {
      this.removeDialog({ id: 'sqlGroupView_0' });
    },
    changeDisabledTab() {
      this.items[1].isDisable = false;
    },
    changeName(data) {
      this.dba_name = data.name;
      this.dba_ins = data.dbIns;
    },
    changeResultTest(data) {
      this.outputFileContent = '';
      this.resultTestField = data;
    },
    resetResultTestField() {
      this.resultTestField = '';
      this.resultTest = {};
    },
    saveDBAdapter() {
      this.messageList = [];
      if (!this.allowSave) {
        this.messageList.push(this.$t('msg.dbAdapter.invalidExecute'));
        return;
      }
      let config = this.$refs.DBInterfaceConfig.$data.saveData;
      let mapper = this.$refs.mapper;
      this.saveAll = {
        config_from: config.CONF_FROM,
        config_to: config.CONF_TO,
        config_module: config.CONF_MODULE,
        conf_add: config.CONF_ADDRESS,
        conf_port: config.CONF_PORT,
        conf_instance: config.CONF_DBINSTANCE,
        conf_table: config.CONF_TABLE,
        comp_id: this.db_item.comp_id,
        dba_type: this.db_item.dba_type,
        agent_id: this.db_item.agent_id,
        dba_conf_id: config.CONF_ID,
        dba_mapper_id: this.dbMapperId || this.saveMapper.mapper_id || '',
        dba_interval: this.db_item.dba_interval,
        dba_interval_type: this.db_item.dba_interval_type,
        sql_grp_id: '',
        dba_name: this.fullName,
      };

      if (this.db_item.dba_type == 'D2D') {
        this.saveAll.sql_grp_id = mapper.$data.sqlGroupId || mapper.$data.saveDBMapping.sql_grp_id;
        this.saveAll.target_agent_id = this.db_item.target_agent_id;
      }
      if (this.db_item.dba_type == 'D2J') {
        this.saveAll.sql_grp_id = mapper.$data.sqlGroupId || mapper.$data.saveDBMapping.sql_grp_id;
        if (!this.saveAll.dba_conf_id)
          this.messageList.push(this.$t('msg.dbAdapter.invalidConfig'));
        if (!mapper.isValidMapper) this.messageList.push(this.$t('msg.dbAdapter.invalidMapper'));
        else if (!this.saveAll.dba_mapper_id)
          this.messageList.push(this.$t('msg.dbAdapter.validSaveMapper'));
        if (!this.saveAll.sql_grp_id) this.messageList.push(this.$t('msg.dbAdapter.invalidSQL'));
      } else if (this.db_item.dba_type == 'J2D') {
        this.saveAll.sql_grp_id = mapper.$data.sqlGroupId || mapper.$data.saveDBMapping.sql_grp_id;
        if (!this.saveAll.dba_conf_id)
          this.messageList.push(this.$t('msg.dbAdapter.invalidConfig'));
        if (!mapper.isValidMapper) this.messageList.push(this.$t('msg.dbAdapter.invalidMapper'));
        else if (!this.saveAll.dba_mapper_id)
          this.messageList.push(this.$t('msg.dbAdapter.validSaveMapper'));
        if (!mapper.$data.jsonFileID) this.messageList.push(this.$t('msg.dbAdapter.invalidJSON'));
      } else if (!this.saveAll.dba_conf_id) {
        this.messageList.push(this.$t('msg.dbAdapter.invalidConfig'));
      }
      if (this.messageList.length > 0) return;

      let dbaId = nullOrEmpty(this.$route.params.id);
      this.isLoading = true;
      if (dbaId && dbaId != '0') {
        this.saveAll.dba_id = this.$route.params.id;
        this.$store
          .dispatch('updateDBAdapter', this.saveAll)
          .then((res) => {
            this.isLoading = false;
            this.$refs.messageDialog.dialog = true;
            this.checkDialogColor = 'success';
            this.checkDialogInfo = 'DB Adapter has been updated successfully';
          })
          .catch((ex) => {
            this.isLoading = false;
            this.checkDialogColor = 'error';
            this.checkDialogInfo = 'Fail';
            this.$refs.messageDialog.dialog = true;
          });
      } else {
        this.saveAll.dba_interval = '3';
        this.saveAll.dba_interval_type = 'MM';
        this.saveAll.type_check = 'DBName';
        this.$store
          .dispatch('checkDBConfig', this.saveAll)
          .then((res) => {
            if (res == 'OK') {
              this.$store
                .dispatch('insertDBAdapter', this.saveAll)
                .then((res) => {
                  this.isLoading = false;
                  this.$refs.messageDialog.dialog = true;
                  this.checkDialogColor = 'success';
                  this.checkDialogInfo = 'DB Adapter has been saved successfully';
                  this.param.options.isEdit = true;
                  this.$route.params.id = res;
                })
                .catch((ex) => {
                  this.isLoading = false;
                  this.checkDialogColor = 'error';
                  this.checkDialogInfo = 'Fail';
                  this.$refs.messageDialog.dialog = true;
                });
            } else {
              this.isLoading = false;
              this.checkDialogColor = 'validation';
              this.checkDialogInfo = res;
              this.$refs.messageDialog.dialog = true;
            }
          })
          .catch((e) => {
            this.isLoading = false;
            this.checkDialogColor = 'error';
            this.checkDialogInfo = 'Fail';
            this.$refs.messageDialog.dialog = true;
          });
      }
    },
    saveMapperCheckIn() {
      if (!this.db_item.dba_type) {
        this.detailValid = this.$t('msg.common.typeRequire', ['Type']);
        this.$refs.validateDate.dialog = true;
        return;
      }
      let mapper = this.$refs.mapper.$data;
      let config = this.$refs.DBInterfaceConfig.$data.saveData;
      this.saveMapper = {
        agent_id: this.db_item.agent_id,
        mapper_name: mapper.mapperFileName,
        mapper_type: this.db_item.dba_type,
        sql_grp_id: mapper?.sqlGroupId || '',
        mapper_file_id: mapper?.mapperFileID || '',
        file_content: mapper?.mapperFileContent || '',
        mapper_file_comment: mapper?.xml_file_comment || '',
        conf_add: config.CONF_ADDRESS,
        conf_port: config.CONF_PORT,
      };
      this.isLoading = true;
      if (this.dbMapperId && this.checkIn) {
        this.saveMapper.mapper_id = this.dbMapperId;
        this.$store
          .dispatch('deployDBMapperAdapter', this.saveMapper)
          .then((response) => {
            this.isLoading = false;
            this.$refs.messageDialog.dialog = true;
            this.checkDialogColor = 'success';
            this.checkDialogInfo = 'DB mapper has been deployed successfully';
          })
          .catch((ex) => {
            this.isLoading = false;
          });
      } else {
        this.$store
          .dispatch('insertDBMapperAdapter', this.saveMapper)
          .then(() => {
            this.isLoading = false;
            this.checkIn = true;
          })
          .catch((ex) => {
            this.isLoading = false;
          });
      }
    },
    getParamsTest() {
      let params = {};
      let dbMapper = this.$refs.mapper;
      this.xmlMapperType = this.db_item.dba_type;
      this.mapperFileContent = dbMapper.mapperFileContent;
      this.jsonFileContent = dbMapper.jsonFileContent;
      this.sqlList = dbMapper.sqlGroupList;
      let dbConfigDetail = this.$refs.DBInterfaceConfig.saveData;
      if (this.xmlMapperType == 'D2J') {
        let queries = [];
        for (let i = 0; i < this.sqlList.length; i++) {
          let sql_cnt_id = this.sqlList[i].sql_cnt_id;
          let sql_cnt_txt = this.sqlList[i].sql_cnt_txt;
          queries.push({ sql_cnt_id: sql_cnt_id, sql_cnt_txt: sql_cnt_txt });
        }
        params = {
          mapper_type: this.xmlMapperType,
          conf_instance: dbConfigDetail.CONF_DBINSTANCE,
          conf_table: dbConfigDetail.CONF_TABLE,
          conf_id: dbConfigDetail.CONF_ID,
          conf_add: dbConfigDetail.CONF_ADDRESS,
          conf_port: dbConfigDetail.CONF_PORT,
          queries: queries,
          mapper_content: this.mapperFileContent,
        };
        return params;
      } else if (this.xmlMapperType == 'D2D') {
        let queries = [];
        for (let i = 0; i < this.sqlList.length; i++) {
          let sql_cnt_id = this.sqlList[i].sql_cnt_id;
          let sql_cnt_txt = this.sqlList[i].sql_cnt_txt;
          let sql_func_type = this.sqlList[i].sql_func_type;
          let sql_db_instance = this.sqlList[i].sql_db_instance;
          let sql_grp_id = this.sqlList.sql_grp_id;
          queries.push({
            sql_cnt_id,
            sql_cnt_txt,
            sql_func_type,
            sql_grp_id,
            sql_db_instance,
          });
        }
        params = {
          mapper_type: this.xmlMapperType,
          conf_instance: dbConfigDetail.CONF_DBINSTANCE,
          conf_table: dbConfigDetail.CONF_TABLE,
          conf_id: dbConfigDetail.CONF_ID,
          conf_add: dbConfigDetail.CONF_ADDRESS,
          conf_port: dbConfigDetail.CONF_PORT,
          queries: queries,
        };
        return params;
      } else if (this.xmlMapperType == 'J2D') {
        params = {
          mapper_type: this.xmlMapperType,
          conf_instance: dbConfigDetail.CONF_DBINSTANCE,
          conf_table: dbConfigDetail.CONF_TABLE,
          conf_id: dbConfigDetail.CONF_ID,
          conf_add: dbConfigDetail.CONF_ADDRESS,
          conf_port: dbConfigDetail.CONF_PORT,
          mapper_content: this.mapperFileContent,
          jsonFileContent: this.jsonFileContent,
        };
        return params;
      } else if (this.xmlMapperType == 'D2F') {
        let queries = [];
        for (let i = 0; i < this.sqlList.length; i++) {
          let sql_cnt_id = this.sqlList[i].sql_cnt_id;
          let sql_cnt_txt = this.sqlList[i].sql_cnt_txt;
          queries.push({ sql_cnt_id: sql_cnt_id, sql_cnt_txt: sql_cnt_txt });
        }
        params = {
          mapper_type: this.xmlMapperType,
          conf_instance: dbConfigDetail.CONF_DBINSTANCE,
          conf_id: dbConfigDetail.CONF_ID,
          conf_table: dbConfigDetail.CONF_TABLE,
          conf_add: dbConfigDetail.CONF_ADDRESS,
          conf_port: dbConfigDetail.CONF_PORT,
          queries: queries,
        };
        return params;
      }
    },
    testMapper() {
      this.messageList = [];
      if (!this.db_item.dba_type) {
        this.messageList.push(this.$t('msg.dbAdapter.invalidType'));
        return;
      }
      let config = this.$refs.DBInterfaceConfig.$data.saveData;
      let mapper = this.$refs.mapper;
      const checkParams = {
        dba_type: this.db_item.dba_type,
        dba_conf_id: config.CONF_ID,
        dba_mapper_id: this.dbMapperId || this.saveMapper.mapper_id || '',
        sql_grp_id: '',
      };

      if (this.db_item.dba_type == 'D2J') {
        checkParams.sql_grp_id = mapper.$data.sqlGroupId || mapper.$data.saveDBMapping?.sql_grp_id;
        if (!checkParams.dba_conf_id) this.messageList.push(this.$t('msg.dbAdapter.invalidConfig'));
        if (mapper.isEmptyMapper) this.messageList.push(this.$t('msg.dbAdapter.emptyMapper'));

        if (!checkParams.sql_grp_id) this.messageList.push(this.$t('msg.dbAdapter.invalidSQL'));
      } else if (this.db_item.dba_type == 'J2D') {
        checkParams.sql_grp_id = mapper.$data.sqlGroupId || mapper.$data.saveDBMapping?.sql_grp_id;
        if (!checkParams.dba_conf_id) this.messageList.push(this.$t('msg.dbAdapter.invalidConfig'));
        if (mapper.isEmptyMapper) this.messageList.push(this.$t('msg.dbAdapter.emptyMapper'));

        if (mapper.isEmptyJson) this.messageList.push(this.$t('msg.dbAdapter.invalidJSON'));
      } else if (!checkParams.dba_conf_id) {
        this.messageList.push(this.$t('msg.dbAdapter.invalidConfig'));
      }
      if (this.messageList.length > 0) return;
      this.resetResultTestField();
      let params = this.getParamsTest();
      this.mapperFileName = mapper.mapperFileName;
      this.mapperFileExtension = mapper.mapperFileExtension;
      this.mapperFileStatus = mapper.mapperFileStatus;
      this.mapperFileID = mapper.mapperFileID;
      const testedParam = {
        FILE_NAME: this.mapperFileName,
        FILE_CONTENT: this.mapperFileContent,
        FILE_TYPE: this.mapperFileExtension,
        FILE_STATUS: this.mapperFileStatus,
        FILE_ID: this.mapperFileID,
      };
      if (this.xmlMapperType == 'D2J') {
        this.$store.dispatch('testDbAdapterMapper', params).then(() => {
          this.resultTest = this.$store.getters.resultTestDbAdapter;
          this.resultTestField =
            nullOrEmpty(this.resultTest.result.status, '\n') +
            nullOrEmpty(this.resultTest.result.url, '\n') +
            nullOrEmpty(this.resultTest.result.detail);
          let outputFileContentList = this.resultTest.contents;
          if (this.isJson(outputFileContentList)) {
            this.outputFileContent = JSON.stringify(JSON.parse(outputFileContentList), null, 4);
            this.isJsonFile = true;
          } else {
            this.outputFileContent = `${outputFileContentList}`;
            this.isJsonFile = false;
          }
          if (this.resultTest.result.check != undefined) {
            testedParam.FILE_STATUS = this.resultTest.result.check == 'OK' ? 'Executed' : 'Failed';
            Store.dispatch('updateXmlMapBuiderFile', testedParam);
          }
          if (this.resultTest.result.check == 'OK') this.allowSave = true;
        });
      } else if (this.xmlMapperType == 'D2D') {
        this.$store.dispatch('testDbAdapterMapper', params).then(() => {
          this.resultTest = this.$store.getters.resultTestDbAdapter;
          this.resultTestField =
            nullOrEmpty(this.resultTest.result.status, '\n') +
            nullOrEmpty(this.resultTest.result.url, '\n') +
            nullOrEmpty(this.resultTest.result.detail);
          let outputFileContentList = this.resultTest.contents;
          if (this.isJson(outputFileContentList)) {
            this.outputFileContent = JSON.stringify(JSON.parse(outputFileContentList), null, 4);
            this.isJsonFile = true;
          } else {
            this.outputFileContent = `${outputFileContentList}`;
            this.isJsonFile = false;
          }
          if (this.resultTest.result.check == 'OK') this.allowSave = true;
        });
      } else if (this.xmlMapperType == 'J2D') {
        this.$store.dispatch('testDbAdapterMapper', params).then(() => {
          this.resultTest = this.$store.getters.resultTestDbAdapter;
          this.resultTestField =
            nullOrEmpty(this.resultTest.result.status, '\n') +
            nullOrEmpty(this.resultTest.result.detail);

          if (this.resultTest.result.check != undefined) {
            testedParam.FILE_STATUS = this.resultTest.result.check == 'OK' ? 'Executed' : 'Failed';
            Store.dispatch('updateXmlMapBuiderFile', testedParam);
          }
          if (this.mapperFileContent == '' || this.mapperFileContent == undefined) {
            this.resultTestField += '[NO INPUT JSON]';
          }
          if (this.resultTest.result.status == '[CONNECTION: OK]') this.allowSave = true;
        });
      } else if (this.xmlMapperType == 'D2F') {
        this.$store.dispatch('testDbAdapterMapper', params).then(() => {
          this.resultTest = this.$store.getters.resultTestDbAdapter;
          this.resultTestField =
            nullOrEmpty(this.resultTest.result.status, '\n') +
            nullOrEmpty(this.resultTest.result.url, '\n') +
            nullOrEmpty(this.resultTest.result.detail);
          let outputFileContentList = this.resultTest.contents;
          for (let i = 0; i < outputFileContentList.length; i++) {
            this.outputFileContent += outputFileContentList[i];
            this.outputFileContent += '\n';
          }
          if (this.resultTest.result.check != undefined) {
            testedParam.FILE_STATUS = this.resultTest.result.check == 'OK' ? 'Executed' : 'Failed';
            Store.dispatch('updateXmlMapBuiderFile', testedParam);
          }
          if (this.resultTest.result.check == 'OK') this.allowSave = true;
        });
      }
      if (this.outputFileContentList == undefined || this.outputFileContentList == '') {
        this.outputFileContent = '<<TESTED: NO OUTPUT>>';
      }
    },
    isJson(str) {
      try {
        JSON.parse(str);
      } catch (e) {
        return false;
      }
      return true;
    },
    saveDBConfig(item) {
      this.saveData = item;
      this.saveData.agent_id = this.db_item.agent_id;
      if (!this.db_item.dba_type) {
        this.detailValid = this.$t('msg.common.typeRequire', ['Type']);
        this.$refs.validateDate.dialog = true;
        return;
      }
      if (!this.saveData.CONF_NAME) {
        this.detailValid = this.$t('msg.common.require', ['Name']);
        this.$refs.validateDate.dialog = true;
        return;
      }
      this.isLoading = true;
      if (this.dbConfigId) {
        this.saveData.CONF_ID = this.dbConfigId;
        this.$store
          .dispatch('updateDBAdapterConfig', this.saveData)
          .then(() => {
            this.$store
              .dispatch('getDBAdapterConfigList', {
                agent_id: this.db_item.agent_id,
                target_agent_id: this.db_item.target_agent_id,
              })
              .then(() => {
                this.dbConfigList = this.dbAdapterConfigList;
              });
            this.isLoading = false;
            this.$refs.messageDialog.dialog = true;
            this.checkDialogColor = 'success';
            this.checkDialogInfo = 'Update success!';
            this.$refs.DBInterfaceConfig.$data.allowSave = false;
          })
          .catch((ex) => {
            this.isLoading = false;
            this.checkDialogColor = 'error';
            this.checkDialogInfo = 'Fail';
            this.$refs.messageDialog.dialog = true;
          });
      } else {
        this.$store
          .dispatch('insertDBAdapterConfig', this.saveData)
          .then(() => {
            this.$store
              .dispatch('getDBAdapterConfigList', {
                agent_id: this.db_item.agent_id,
                target_agent_id: this.db_item.target_agent_id,
              })
              .then(() => {
                this.dbConfigList = this.dbAdapterConfigList;
              });
            this.isLoading = false;
            this.$refs.messageDialog.dialog = true;
            this.checkDialogColor = 'success';
            this.checkDialogInfo = 'DB Interface Configuration has been saved successfully';
            this.$refs.DBInterfaceConfig.$data.allowSave = false;
            if (this.dbConfigId) {
              this.saveData.CONF_ID = this.dbConfigId;
              this.items[1].isDisable = false;
            }
          })
          .catch((ex) => {
            this.isLoading = false;
            this.checkDialogColor = 'error';
            this.checkDialogInfo = 'Fail';
            this.$refs.messageDialog.dialog = true;
          });
      }
    },
    deleteDBConfig(item) {
      this.saveData = item;
      this.saveData.agent_id = this.db_item.agent_id;
      console.log('/////// deleteDBConfig');
      this.isLoading = true;
      this.$store
        .dispatch('deleteDBAdapterConfig', this.saveData)
        .then(() => {
          this.$store
            .dispatch('getDBAdapterConfigList', {
              agent_id: this.db_item.agent_id,
              target_agent_id: this.db_item.target_agent_id,
            })
            .then(() => {
              this.dbConfigList = this.dbAdapterConfigList;
            });
          this.isLoading = false;
          this.$refs.messageDialog.dialog = true;
          this.checkDialogColor = 'success';
          this.checkDialogInfo = 'Delete success!';
        })
        .catch((ex) => {
          this.isLoading = false;
          this.checkDialogColor = 'error';
          this.checkDialogInfo = 'Fail';
          this.$refs.messageDialog.dialog = true;
        });
    },
    refeshListSQLManage() {
      this.$refs.sqlGroupView[0].getGroupList();
    },
    reFreshMapVersion() {
      this.$refs.DBMapperList[0].queryMapList();
    },
    closeMapperListDialog() {
      this.removeDialog({ id: 'xmlMapperList_0' });
      this.removeDialog({ id: 'versionHistory_0' });
    },
    onChangeAgent() {
      this.dbInstnList = [];
      this.controlTableList = [];
      this.$refs.DBInterfaceConfig.resetDBConfigData();
      if (this.$refs.mapper) this.$refs.mapper.resetDataMapp();
      this.items[1].isDisable = true;

      if (this.db_item.dba_type === 'D2J' || this.db_item.dba_type === 'D2F') {
        this.db_item.agent_id = this.db_item.source_agent_id;
        this.db_item.target_agent_id = null;
      } else if (this.db_item.dba_type === 'J2D') {
        this.db_item.agent_id = this.db_item.target_agent_id;
        this.db_item.target_agent_id = null;
      } else if (this.db_item.dba_type === 'D2D') {
        this.db_item.agent_id = this.db_item.source_agent_id;
      } else {
        this.db_item.agent_id = this.db_item.source_agent_id;
        this.db_item.target_agent_id = null;
      }
      const index = this.agentList.findIndex((val) => {
        return val.agentId === this.db_item.agent_id;
      });
      this.db_item.comp_id = this.agentList[index].compId;
      if (
        (this.db_item.dba_type === 'D2D' &&
          this.db_item.source_agent_id &&
          this.db_item.target_agent_id) ||
        (this.db_item.dba_type !== 'D2D' && this.db_item.agent_id)
      ) {
        this.$store
          .dispatch('getDbAgentListByAgent', {
            agent_id: this.db_item.agent_id,
            target_agent_id: this.db_item.target_agent_id,
          })
          .then(() => {
            this.dbInstnList = this.dbInstanceList;
            this.controlTableList = this.interfaceControlTableList;
          });
        this.$store
          .dispatch('getDBAdapterConfigList', {
            agent_id: this.db_item.agent_id,
            target_agent_id: this.db_item.target_agent_id,
          })
          .then(() => {
            this.dbConfigList = this.dbAdapterConfigList;
          });
      } else {
        this.dbInstnList = [];
        this.controlTableList = [];
        this.dbConfigList = [];
      }
    },
    openLoadFile(data) {
      this.prs = {
        CUST_ID: 'cyberlogitec.com',
        STR_SNDR: 'NDAL',
        STR_RCVR: 'CTCT',
        MSG_ID: 'COPARN',
        MSG_VER: 'UND95B',
        DAT_TYPE: 'UPDT',
        FR_DAT: '20200615',
        TO_DAT: '20200715',
        MSG_CNT: null,
        FFL_FILE_NAME: null,
        MAP_NAME: 'test_add_file_modify',
        MAP_CONV_TP: 'F2E',
        FFL_FRMT_TP: null,
        PRCS_STS: 'REPO',
        LAY_PRCS_NO: 'R000000152',
        SRM_PRCS_NO: 'REP0000085',
        ALIAS: '',
        ROWID: 29,
      };
      let type = 'loadFile';
      let item = {
        ROWID: 0,
        data,
      };
      let indexArrDialog = this.findDialog('loadFile_0');
      if (indexArrDialog != null) {
        return;
      }
      this.newDialog(item, type) - 1;
    },
    findDialog(id, dialogs) {
      if (!dialogs) dialogs = this.dialogs;
      let index = dialogs.findIndex((val) => {
        return val.id === id;
      });
      return index > -1 ? index : null;
    },
    newDialog(item, type) {
      return this.dialogs.push(this.generateDialog(item, type));
    },
    generateDialog(item, type) {
      let id = `${type}_${item.ROWID}`;
      this.arrLayoutDialog.push({ id: id });
      this.dialogId++;
      let name = 'Dialog ' + id;
      let options = { left: 30 * this.dialogId, top: 30 * this.dialogId, item };
      return { id, name, type, options };
    },
    removeDialog(dialog) {
      let id = dialog.id;
      let index = this.findDialog(id);
      let indexArrDialog = this.findDialog(id, this.arrLayoutDialog);
      this.arrLayoutDialog.splice(indexArrDialog, 1);
      this.dialogs.splice(index, 1);
      if (this.selected && this.selected.id === id) this.selected = null;
    },
    dialogDragEnd(obj) {
      let index = this.findDialog(obj.id);
      this.$set(this.dialogs[index].options, 'left', obj.left);
      this.$set(this.dialogs[index].options, 'top', obj.top);
    },
    selectDialog(obj) {
      let index = this.findDialog(obj.id);
      this.selected = this.dialogs[index];
    },
    openXmlMapperListDialog() {
      let type = 'xmlMapperList';
      const data = {
        agent_id: this.db_item.agent_id,
      };
      let item = {
        ROWID: 0,
        item: data,
      };
      let indexArrDialog = this.findDialog('xmlMapperList_0');
      if (indexArrDialog != null) {
        return;
      }
      this.newDialog(item, type) - 1;
    },
    openDBMapperVersion(itemRow) {
      let type = 'versionHistory';
      let item = {
        ROWID: 0,
        data: itemRow,
        action: 'dbmapbuilder',
      };
      let indexArrDialog = this.findDialog('versionHistory_0');
      if (indexArrDialog != null) {
        return;
      }
      this.newDialog(item, type) - 1;
    },
    openDBAdapterSQL() {
      let type = 'sqlGroupView';
      let item = {
        ROWID: 0,
      };
      let indexArrDialog = this.findDialog('sqlGroupView_0');
      if (indexArrDialog != null) {
        return;
      }
      this.newDialog(item, type) - 1;
    },
    openQueryPoolDialog(codeCtg) {
      let type = 'QueryPool';
      let item = {
        ROWID: 0,
        codeCtg: this.codeCtg,
      };
      let indexArrDialog = this.findDialog('QueryPool_0');
      if (indexArrDialog != null) {
        return;
      }
      this.newDialog(item, type) - 1;
    },
    openAddSQLGroup(itemSql) {
      let type = 'addSqlGroup';
      let item = {};
      if (itemSql) {
        item = {
          ROWID: 0,
          action: 'modify',
          selectedRow: itemSql,
        };
      } else {
        item = {
          ROWID: 0,
          action: 'add',
        };
      }
      let indexArrDialog = this.findDialog('addSqlGroup_0');
      if (indexArrDialog != null) {
        return;
      }
      this.newDialog(item, type) - 1;
    },
    openAddD2DSQLGroup(itemSql) {
      let type = 'addD2DSqlGroup';
      let item = {};
      if (itemSql) {
        item = {
          ROWID: 0,
          action: 'modify',
          selectedRow: itemSql,
        };
      } else {
        item = {
          ROWID: 0,
          action: 'add',
        };
      }
      let indexArrDialog = this.findDialog('addD2DSqlGroup_0');
      if (indexArrDialog != null) {
        return;
      }
      this.newDialog(item, type) - 1;
    },
    resetData() {
      this.items[1].isDisable = true;
      const dbItem = this.db_item;
      this.db_item = {
        type: '',
      };
      this.db_item.dba_name = dbItem.dba_name;
      this.db_item.dba_type = dbItem.dba_type;
      this.db_item.comp_id = dbItem.comp_id;
      this.db_item.agent_id = dbItem.agent_id;
    },
    closeWindow(type) {
      const message = {
        message: type,
      };
      if (window.opener && !window.opener.closed) {
        window.opener.postMessage(message, '*');
      }

      setTimeout(() => {
        window.close();
      }, 50);
    },
  },
};
</script>
